<div class="ov column">
  {{ item?.number || '---' }}
</div>
<div class="timestamp column">
  {{ date || '---' }}
</div>
<div class="products column">
  <ng-container *ngIf="item?.products.length > 0">
    <div class="product" *ngFor="let p of item?.products">{{ p.name || '---' }}</div>
  </ng-container>
  <ng-container *ngIf="item?.products.length === 0">
    <div class="product">---</div>
  </ng-container>
</div>
<div class="quantity column">
  <ng-container *ngIf="item?.products.length > 0">
    <div *ngFor="let p of item?.products">{{ p.quantity || '---' }}</div>
  </ng-container>
  <ng-container *ngIf="item?.products.length === 0">
    <div>---</div>
  </ng-container>
</div>
<div class="status column">
  {{ translateStatus(item?.status) }}
</div>
<div class="availability column">
  <div *ngIf="checkingAvailability" class="spinner-cell" aria-live="polite">
    <mat-progress-spinner [diameter]="18" mode="indeterminate"></mat-progress-spinner>
  </div>
  <div *ngIf="!checkingAvailability">
    <span class="avail-dot" [ngClass]="{'ok': isAvailable, 'missing': !isAvailable}" aria-hidden="true"></span>
  </div>
</div>
<div class="reserve-button">
  <button [matTooltip]="showTooltip()"
          [disabled]="disabled"
          mat-raised-button
          class="primary-1"
          (click)="processClickHandler($event)">PROCESSAR</button>
</div>
